module.exports = __webpack_public_path__ + "static/img/home.a34b4da9.svg";